import React, { ReactNode, useMemo } from 'react';

import { detailWrap } from 'styles/table';
import { UiComponent } from 'components';
import { usePageOption } from 'hooks';
import { tableWrap } from 'styles/table';
import { IEvent } from 'types';
import { Link, useParams } from 'react-router-dom';
import { EnrollQuery } from 'queries';

const COLS = ['ID', '봉사명', '봉사시간'];

type Data = {
  event: IEvent;
};

function Volunteer() {
  const { id } = useParams<{ id: string }>();
  const pageState = usePageOption();

  const { data } = EnrollQuery.useGetAllByUser({
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    userId: Number(id),
  });

  const renderer: Record<
    (typeof COLS)[number],
    (data: Data & { row: number }) => ReactNode
  > = useMemo(
    () => ({
      ID: ({ event: { id } }: Data) => <Link to={`/event/${id}`}>{id}</Link>,
      봉사명: ({ event: { title } }: Data) => <>{title}</>,
      봉사시간: ({ event: { volunteerHours } }: Data) =>
        Number(volunteerHours || 0),
    }),
    [],
  );

  return (
    <div css={[detailWrap, { marginTop: '24px' }]}>
      <h3>봉사활동 참여내역</h3>
      <div css={tableWrap}>
        <UiComponent.Table
          cols={COLS}
          renderer={renderer}
          data={data?.data || []}
          sticky
        />
      </div>
      <UiComponent.Pagination
        {...pageState}
        totalPage={data?.totalPages || 1}
      />
    </div>
  );
}

export default Volunteer;
